import * as Icons from "lucide-react";
export function Icon({ name, ...p }) { const C = Icons[name] || Icons.Circle; return <C {...p} />; }

export function PageHeader({ title, subtitle, icon, color = "#3B82F6", action, demo = true }) {
  return (
    <div className="flex flex-wrap items-start gap-4 mb-7">
      {icon && <div className="w-12 h-12 rounded-2xl grid place-items-center shrink-0" style={{ background: `${color}18` }}><Icon name={icon} size={24} style={{ color }} /></div>}
      <div className="min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <h1 className="font-head text-2xl md:text-3xl font-bold tracking-tight">{title}</h1>
          {demo && <DemoBadge />}
        </div>
        {subtitle && <p className="text-gray-500 mt-1">{subtitle}</p>}
      </div>
      {action && <div className="ml-auto">{action}</div>}
    </div>
  );
}

export function DemoBadge({ label = "Demo data" }) {
  return <span className="inline-flex items-center gap-1 text-[11px] font-semibold bg-amber-50 text-amber-600 border border-amber-200 rounded-full px-2 py-0.5" data-testid="demo-badge"><Icon name="Info" size={11} /> {label}</span>;
}

export function DataSource({ src = "Illustrative demo data", updated = "Today, 9:15 AM" }) {
  return <div className="text-[11px] text-gray-400 flex items-center gap-3 mt-3"><span>Source: {src}</span><span>·</span><span>Last updated: {updated}</span></div>;
}

export function Card({ children, className = "", ...p }) {
  return <div className={`card-mfx p-6 ${className}`} {...p}>{children}</div>;
}

export function Stat({ label, value, delta, color = "#3B82F6", icon }) {
  return (
    <div className="card-mfx p-5 hover-lift">
      <div className="flex items-center justify-between">
        <span className="text-xs text-gray-500">{label}</span>
        {icon && <Icon name={icon} size={16} style={{ color }} />}
      </div>
      <div className="font-head font-bold text-2xl mt-2" style={{ color }}>{value}</div>
      {delta != null && <div className={`text-xs mt-1 font-medium ${delta >= 0 ? "text-emerald-600" : "text-red-500"}`}>{delta >= 0 ? "▲" : "▼"} {Math.abs(delta)}%</div>}
    </div>
  );
}

export function Btn({ children, variant = "primary", className = "", ...p }) {
  const styles = {
    primary: "grad-amber text-black amber-glow hover:brightness-105",
    soft: "bg-amber-500/10 text-amber-400 hover:bg-amber-500/20",
    outline: "bg-white border border-gray-200 text-gray-700 hover:border-gray-300",
    dark: "bg-[#1E2435] text-slate-100 border border-[#2E384D] hover:bg-[#252C40]",
  };
  return <button className={`px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors inline-flex items-center gap-2 ${styles[variant]} ${className}`} {...p}>{children}</button>;
}

export function AIDisclaimer({ text = "AI-generated · assistive only. Not investment advice. Verify against official sources and AMC/compliance approval where required." }) {
  return <div className="flex items-start gap-2 text-[11px] text-gray-400 bg-gray-50 rounded-xl px-3 py-2 mt-3"><Icon name="ShieldAlert" size={13} className="mt-0.5 shrink-0" /><span>{text}</span></div>;
}
